export default __webpack_public_path__ + "static/empleados-000e93be62337f25d9ceaa425156855c.png";